import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import DateTime from "../../../../components/Formatters/DateTime";
import TextSpinner from "../../../../components/UI/Spinner/TextSpinner";
import useDetalhamento from "../hooks/useDetalhamento";
import FormDemonstrativos from "../FormDemonstrativos";
import HtmlToString from "../../../../components/Formatters/HtmlToString";
import useMontarLogica from "../hooks/useMontarLogica";
import constants from "../../../Constants";

const columns = [
  {
    name: "Descrição",
    cell: (row) => <HtmlToString html={row.dsItem} />,
    minWidth: "20%",
  },
  {
    name: "Referência",
    selector: (row) => row.txReferencia,
    minWidth: "10%",
    center: true,
  },
  {
    name: "Data de Vencimento",
    selector: (row) => row.dtVencimento,
    minWidth: "10%",
    cell: (row) => <DateTime value={row.dtVencimento} stringFormat="dd/MM/yyyy" />,
    center: true,
  },

  {
    name: "ICMS Declarado",
    selector: (row) =>
      row.vlDeclarado
        ? row.vlDeclarado.toLocaleString("pt-BR", { style: "currency", currency: "BRL" })
        : row.vlDeclarado,
    minWidth: "10%",
    center: true,
  },
  {
    name: "ICMS Apurado",
    selector: (row) =>
      row.vlApurado ? row.vlApurado.toLocaleString("pt-BR", { style: "currency", currency: "BRL" }) : row.vlApurado,
    minWidth: "10%",
    center: true,
  },
  {
    name: "ICMS Recolhido",
    selector: (row) =>
      row.vlIcmsRecolhido
        ? row.vlIcmsRecolhido.toLocaleString("pt-BR", { style: "currency", currency: "BRL" })
        : row.vlIcmsRecolhido,
    minWidth: "10%",
    center: true,
  },

  {
    name: "ICMS a Recolher",
    selector: (row) => row.vlIcms.toLocaleString("pt-BR", { style: "currency", currency: "BRL" }),
    minWidth: "10%",
    center: true,
  },
  {
    name: "Multa",
    selector: (row) => row.vlMultaOcorrenciaAtual.toLocaleString("pt-BR", { style: "currency", currency: "BRL" }),
    minWidth: "10%",
    center: true,
  },
  {
    name: "Total",
    selector: (row) =>
      (row.vlMultaOcorrenciaAtual + row.vlIcms).toLocaleString("pt-BR", { style: "currency", currency: "BRL" }),
    minWidth: "10%",
    center: true,
  },
];

const conditionalRowStyles = [
  {
    when: (row) => row.dsItem === "Total",
    style: { backgroundColor: "#d3d3d3", cursor: "not-allowed" },
  },
];

const ListagemJ1 = ({ history, sqItemOcorrencia, sqAcaoFiscal }) => {
  const [reload, setReload] = useState(false);
  const { dataWithTotal, totalRows, isLoading, handlePageChange } = useDetalhamento({
    sqAcaoFiscal,
    sqItemOcorrencia,
    reload, // Passando para o hook para atualizar os dados
  });

  const [dados, setDados] = useState({});

  const { montarLogica, mostrarLista, setMostrarLista } = useMontarLogica();

  useEffect(() => {
    if (mostrarLista) {
      montarLogica(1);
    }
  }, [montarLogica, mostrarLista, reload]);

  const voltarListagem = () => {
    setMostrarLista(true);
    setReload((prev) => prev + 1);
  };

  return mostrarLista ? (
    <DataTable
      noHeader
      keyField="sqItemOcorrencia"
      columns={columns}
      data={dataWithTotal}
      progressPending={isLoading}
      noDataComponent="Nenhum registro para exibir"
      progressComponent={<TextSpinner />}
      paginationTotalRows={totalRows}
      pointerOnHover
      pagination
      paginationComponentOptions={constants.paginationComponentOptions}
      onChangePage={handlePageChange}
      onRowClicked={(row) => {
        if (row.dsItem !== "Total") {
          setDados(row);
          montarLogica(4);
        }
      }}
      conditionalRowStyles={conditionalRowStyles}
      selectableRowDisabled={(row) => row.dsItem === "Total"}
      selectableRowsVisibleOnly={(row) => !(row.dsItem === "Total")}
    />
  ) : (
    <FormDemonstrativos
      tipoDetalhamento={dados.tipoDetalhamento}
      sqItemOcorrencia={dados.sqItemOcorrencia}
      sqAcaoFiscal={dados.sqAcaoFiscal}
      dadosOcorrencia={dados}
      history={history}
      voltarListagem={() => voltarListagem()}
    />
  );
};

export default ListagemJ1;
